/**
 * RPA_PC_01
 */

import * as SDISVC from '../SDIService';
import SDIConstants from '../SDIConstants';
import { Dispatcher } from 'simplr-flux';
import * as $ from 'jquery';
import * as MenuAction from './MenuAction';
/**
 * PRA_PC_02
 */

const PageLoadAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ProductReplen,
            SDIConstants.methodNames.ProductReplen_PageLoad,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: "Emitplz", response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * PRA_PC_03
 * 
 * @param {any} BO
 */
const AddtoCartAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ProductReplen,
            SDIConstants.methodNames.ProductReplen_AddtoCart,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ProductReplen_AddtoCart, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * PRA_PC_04
 * @param {any} BO
 */
const PlaceOrerAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ProductReplen,
            SDIConstants.methodNames.ProductReplen_PlaceOrder,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ProductReplen_PlaceOrder, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * PRA_PC_05
 * @param {any} BO
 */
const ItemDetailAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ProductReplen,
            SDIConstants.methodNames.ProductReplen_ItemDetail,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ProductReplen_ItemDetail, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * PRA_PC_06
 * @param {any} BO
 */
const ItemDeleteAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ProductReplen,
            SDIConstants.methodNames.ProductReplen_ItemDelete,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ProductReplen_ItemDelete, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}
/**
 * PRA_PC_07
 * @param {any} BO
 */
const ItemUpdateAction = (BO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.ProductReplen,
            SDIConstants.methodNames.ProductReplen_ItemUpdate,
            JSON.stringify(BO),

            (data) => {
                if (data.success) {
                    ;
                    $(`#${SDIConstants.SDILoader}`).addClass('hide');
                    if (data.response != "" && data.response) {
                        let contentData = { type: SDIConstants.methodNames.ProductReplen_ItemUpdate, response: data.response };
                        ;
                        Dispatcher.dispatch(contentData);
                    }
                }
                else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });
    } catch (ex) {
        console.log(ex)
    }
}

const insertFavPage = async (insertFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_InsertFavPage,
            JSON.stringify(insertFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_InsertFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const deleteFavPage = async (deleteFavPageBO) => {
    try {
        SDISVC.callSecureGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_DeleteFavPage,
            JSON.stringify(deleteFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_DeleteFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

const getCurrentFavPage = async (getFavPageBO) => {
    try {
        SDISVC.callRecurringGateway(
            SDIConstants.moduleNames.Menu,
            SDIConstants.methodNames.Menu_GetCurrentFavPage,
            JSON.stringify(getFavPageBO),
            (data) => {
                if (data.success) {
                    if (data.response != "" && data.response) {
                        let contentData = { type: "NOTIFY_CurrentFavPage", response: data.response };
                        Dispatcher.dispatch(contentData);
                    }
                } else if (data.success == false) {
                    if (data.response) {
                        if (data.response == SDIConstants.tokenExpired) {
                            MenuAction.tokenExpired();
                        }
                    }
                }
            });

    } catch (ex) {
        console.log(ex)
    }
};

export { PageLoadAction, AddtoCartAction, PlaceOrerAction, ItemDetailAction, ItemDeleteAction, ItemUpdateAction, insertFavPage, deleteFavPage, getCurrentFavPage}